import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Button } from './components/Button';
import { useDisabled, useCreateNewChat } from './hooks';

import type { FC } from 'react';

interface NewChatButtonProps {
  gutterTop?: number;
}

export const NewChatButton: FC<NewChatButtonProps> = ({ gutterTop = 0 }) => {
  const { t } = useTranslation();

  const isDisabled = useDisabled();
  const createNewChat = useCreateNewChat();

  return (
    <Box sx={{ px: 2 }}>
      <Button
        sx={{ mt: gutterTop }}
        variant="outlined"
        disabled={isDisabled}
        onClick={createNewChat}
      >
        <AddOutlinedIcon />
        {t('pages.parentHelper.history.newChatButton')}
      </Button>
    </Box>
  );
};
